import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import Employee from 'src/app/model/product/employee';
import IPBoard from 'src/app/model/product/ip-board/ip-board';
import { BaseProject } from 'src/app/model/project/base-project';
import { Project } from 'src/app/model/project/project';
import { EmployeeChoicesService } from 'src/app/services/employee-choices.service';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { Router } from '@angular/router';

@Component({
  selector: 'ip-board-extra-design',
  templateUrl: './ip-board-extra-design.component.html',
  styleUrls: ['./ip-board-extra-design.component.scss'],
})
export class IPBoardExtraDesignComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  project: Project;
  @Input()
  baseProject: BaseProject;
  @Input()
  ipBoard: IPBoard;
  @Output()
  save = new EventEmitter<any>();

  designerChoices: Employee[] = [];

  selectedDesigner: Employee;
  selectedDeadline: Date;
  needsDesignDescription: string;
  emailText: string;
  designSentToCustomer: boolean;
  customerApproves: boolean;
  customerApprovalFeedback: string;

  contactName: string;
  contactEmail: string;

  constructor(
    private employeeChoicesService: EmployeeChoicesService,
    private projectDisplayObservableService: ProjectDisplayObservableService,
    private router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateFirstProjectContact();
    this.addSubscription(
      this.employeeChoicesService.getDesignerChoicesSubscribable(),
      (designers: Employee[]) => {
        this.designerChoices = designers;
      }
    );
    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateFirstProjectContact();
      }
    );
    this.addSubscription(
      this.projectDisplayObservableService.getProductDesignVariableChangedSubscribable(),
      () => {
        this.initializeEditableFields();
      }
    );

    this.initializeEditableFields();
  }

  private initializeEditableFields(): void {
    this.selectedDesigner = this.ipBoard.designer;
    this.selectedDeadline = this.ipBoard.designByDate;
    this.needsDesignDescription = this.ipBoard.needsDesignDescription;
    this.emailText = this.ipBoard.emailText;
    this.designSentToCustomer = this.ipBoard.designSentToCustomer;
    this.customerApproves = this.ipBoard.customerApproves;
    this.customerApprovalFeedback = this.ipBoard.customerApprovalFeedback;
  }

  selectedDesignerChanged(): void {
    this.project.products.forEach((p) => {
      p.designer = this.selectedDesigner;
    });
    this.save.emit();
  }

  selectedDeadlineChanged(): void {
    this.project.products.forEach((p) => {
      p.designByDate = this.selectedDeadline;
    });
    this.save.emit();
  }

  needsDesignDescriptionChanged(value: string): void {
    this.needsDesignDescription = value;
    this.project.products.forEach((p) => {
      p.needsDesignDescription = this.needsDesignDescription;
    });
    this.save.emit();
  }

  emailTextChanged(value: string): void {
    this.emailText = value;
    this.project.products.forEach((p) => {
      p.emailText = this.emailText;
    });
    this.save.emit();
  }

  designSentToCustomerChanged(): void {
    this.project.products.forEach((p) => {
      p.designSentToCustomer = this.designSentToCustomer;
    });
    this.save.emit();
  }

  customerApprovesChanged(): void {
    this.project.products.forEach((p) => {
      p.customerApproves = this.customerApproves;
      if (!this.customerApproves) {
        p.designFinished = false;
      }
    });
    if (!this.customerApproves) {
      this.projectDisplayObservableService
        .getProductDesignVariableChangedSubscribable()
        .next();
    }
    this.save.emit();
  }

  customerApprovalFeedbackChanged(value: string): void {
    this.customerApprovalFeedback = value;
    this.project.products.forEach((p) => {
      p.customerApprovalFeedback = this.customerApprovalFeedback;
    });
    this.save.emit();
  }

  designAssetsChanged(): void {
    this.projectDisplayObservableService
      .getProductAssetsChangedSubscribable()
      .next({ productId: this.ipBoard.id, formSection: 'extraDesign' });
  }

  private calculateFirstProjectContact(): void {
    const firstProjectContact = CollectionHelper.isPopulated(
      this.project.projectContacts
    )
      ? this.project.projectContacts[0]
      : null;
    if (firstProjectContact == null) {
      this.contactName = null;
      this.contactEmail = null;
    } else {
      this.contactName = firstProjectContact.contact.firstName;
      this.contactEmail = CollectionHelper.isPopulated(
        firstProjectContact.contact.emails
      )
        ? firstProjectContact.contact.emails[0].email
        : null;
    }
  }

  compareEntities(o1: any, o2: any): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  goToBord(id: number) {
    this.router.navigateByUrl(`/signs-portal/signs/${id}`);
  }
}
